import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
request.get('/api/v4ward/assess/rectify/page', Object.assign({}, options, { params }));

export const getDetail = (params, options) =>
request.get('/api/v4ward/assess/rectify/detail', Object.assign({}, options, { params }));

export const remove = (params, options) =>
request.post('/api/v4ward/assess/rectify/remove', qs.stringify(params),options);

// 新增/编辑整改记录
export const submitAssessRecord = (params, options) =>
request.post('/api/v4ward/assess/rectify/submit', params,options);

export const update = (params, options) =>
request.post('/api/v4ward/examinereportrectify/edit', params,options);


// 整改结果按钮
export const result = (params, options) =>
request.post('/api/v4ward/examinereportrectify/result', params,options);


// 整改通知按钮 /v4ward/examine/report/rectify
export const rectify = (params, options) =>
request.post('/api/v4ward/examine/report/rectify', params,options);

// // 获取标准名称下拉框 
export const assessTaskList = (params, options) =>
request.get('/api/v4ward/assess/task/assessTaskList', Object.assign({}, options, { params }));

// 根据任务id获取考核标准信息 ，需传参数taskId
export const getStandardByTaskId = (params, options) =>
request.get('/api/v4ward/assess/standard/getStandardByTaskId', Object.assign({}, options, { params }));
 
// 获取标准名称下拉框
// export const getStandardByCondition = (params, options) =>
// request.get('/api/v4ward/assess/standard/getStandardByCondition', Object.assign({}, options, { params }));

// 根据考核对象获取考核标准下拉列表
export const getStandardByCondition = (params, options) =>
request.get('/api/v4ward/assess/standard/getStandardByObjectType', Object.assign({}, options, { params }));



